<template>
<div class="chapter">
<div class="inner_page">
<h1 class="h1"><a id="page_iii"></a>Freedom’s Prophet</h1>
<p class="stitle"><em>Bishop Richard Allen, the AME Church, and the Black Founding Fathers</em></p>
<p class="author">Richard S. Newman</p>
<p class="publisher"><img alt="Image" src="images/pub.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// title.vue?113b5a56